import React from 'react';
import { StringColumn, CustomColumn } from 'baseui/data-table';
import { useStyletron } from 'baseui';
import dayjs from 'dayjs';

export const COL_NAMES = {
	agentName: 'agentName',
	agentID: 'agentID',
	action: 'action',
	actionOwner: 'actionOwner',
	reason: 'reason',
	attachments: 'attachments',
	createdAt: 'createdAt',
	freshdeskTicketId: 'freshdeskTicketId'
};

export const columnConfigs = [
	StringColumn({
		title: 'Ticket Id',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.freshdeskTicketId]
	}),
	StringColumn({
		title: 'Agent Name',
		minWidth: '120',
		mapDataToValue: (data: any) => data[COL_NAMES.agentName]
	}),
	StringColumn({
		title: 'Agent Id',
		minWidth: '150',
		mapDataToValue: (data: any) => data[COL_NAMES.agentID]
	}),
	StringColumn({
		title: 'Action',
		mapDataToValue: (data: any) => data[COL_NAMES.action]
	}),
	StringColumn({
		title: 'Action Owner',
		mapDataToValue: (data: any) => data[COL_NAMES.actionOwner]
	}),
	CustomColumn({
		title: 'Reason',
		minWidth: '200',
		maxWidth: '200',
		mapDataToValue: (data: any) => data[COL_NAMES.reason],
		renderCell: (params: any) => {
			const { value } = params;
			let compressReason = '';
			if (value.length > 30) {
				compressReason = `${value.substr(0, 30)}...`;
			} else {
				compressReason = value;
			}
			return <div title={value}>{compressReason}</div>;
		}
	}),
	CustomColumn({
		title: 'Attachments',
		minWidth: '200',
		maxWidth: '380',
		mapDataToValue: (data: any) => data[COL_NAMES.attachments],
		renderCell: (params: any) => {
			const { value } = params;
			const [css] = useStyletron();

			return (
				<div
					title={value}
					className={css({
						display: 'flex',
						flexWrap: 'wrap',
						overflowY: 'auto',
						height: 'inherit',
						gap: '5px'
					})}>
					{value.map((attachment: any) => {
						return <a href={attachment}>{attachment}</a>;
					})}
				</div>
			);
		}
	}),
	StringColumn({
		title: 'Created At',
		maxWidth: 300,
		mapDataToValue: (data: any) =>
			data[COL_NAMES.createdAt] ? dayjs(new Date(data[COL_NAMES.createdAt])).format('YYYY-MM-DD hh:mm A') : ''
	})
];
